import React from 'react';
import WebsiteLayout from './WebsiteLayout';
import ServicesBanner from './components/servicesBanner';
import Industries from './components/industries';
import FeaturedServices from './components/featuredservices';
import Benefits from './components/benefits';
import Solutions from './components/solutions';



const RoboticsServices = () => {


    return(<>
    <WebsiteLayout>
     <ServicesBanner/>
     <Solutions/>
     <FeaturedServices/>
     <Industries/>
     <Benefits/>
    </WebsiteLayout>
    </>);


}

export default RoboticsServices;